export const getPlanFreeItems = plans => {
  const planFreeItems = {
    bowlCount: 0,
    puptainerCount: 0,
    scooperCount: 0,
  };

  plans.forEach(plan => {
    switch (plan.productType) {
      case 'DY':
        planFreeItems['bowlCount'] += 1;
        planFreeItems['scooperCount'] += 1;
        break;
      case 'FR':
        planFreeItems['puptainerCount'] += 1;
        planFreeItems['scooperCount'] += 1;
        break;
      case 'MX':
        planFreeItems['puptainerCount'] += 1;
        planFreeItems['scooperCount'] += 1;
        break;
      // no default
    }
  });

  return planFreeItems;
};
